const PC_ENTRY_KEY = 'pc-bunnycat-entered-v1';

function initPcStorefront(root) {
  if (!root || root.dataset.pcInitialized === 'true') return;
  root.dataset.pcInitialized = 'true';

  const entry = root.querySelector('[data-pc-entry]');
  const rememberEntry = root.dataset.rememberEntry === 'true';
  const designMode = root.dataset.designMode === 'true';

  const lockPage = () => {
    if (!root.classList.contains('pc-entry-bypassed')) document.body.classList.add('pc-entry-locked');
  };

  const closeEntry = ({ scrollToCatalog = false } = {}) => {
    root.classList.add('pc-entry-is-closed');
    document.body.classList.remove('pc-entry-locked');
    entry?.setAttribute('aria-hidden', 'true');

    if (rememberEntry && !designMode) {
      try {
        sessionStorage.setItem(PC_ENTRY_KEY, '1');
      } catch (error) {}
    }

    if (scrollToCatalog) {
      window.setTimeout(() => {
        root.querySelector('.pc-shop')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 90);
    }
  };

  if (!root.classList.contains('pc-entry-bypassed') || designMode) {
    lockPage();
  } else {
    entry?.setAttribute('aria-hidden', 'true');
  }

  root.querySelectorAll('[data-pc-enter]').forEach((control) => {
    control.addEventListener('click', (event) => {
      const scrollToCatalog = control instanceof HTMLAnchorElement && control.hash;
      if (scrollToCatalog) event.preventDefault();
      closeEntry({ scrollToCatalog: Boolean(scrollToCatalog) });
    });
  });

  root.querySelectorAll('[data-pc-drawer-close]').forEach((link) => {
    link.addEventListener('click', () => {
      root.querySelector('[data-pc-drawer]')?.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const drawer = root.querySelector('[data-pc-drawer][open]');
    if (drawer) {
      drawer.removeAttribute('open');
      return;
    }

    if (!root.classList.contains('pc-entry-is-closed') && !root.classList.contains('pc-entry-bypassed')) {
      closeEntry();
    }
  });
}

function initPcStorefronts(scope = document) {
  scope.querySelectorAll('[data-pc-storefront]').forEach(initPcStorefront);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPcStorefronts(), { once: true });
} else {
  initPcStorefronts();
}

document.addEventListener('shopify:section:load', (event) => initPcStorefronts(event.target));
